import type { ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'
import type { IIap } from '~/types/iap'

import { IapSubTypeBadge } from '~/components/Badges'

const IapSubTypeCellRenderer = ({ value }: ICellRendererParams<IIap, IIap['sub_type']>): ReactElement => {
  return value ? <IapSubTypeBadge value={value} /> : <div />
}

export default IapSubTypeCellRenderer
